import api from './api';
import { saveAs } from '../utils/saveFile';
import type { LocationOpt, BilltoOpt, CustomerOpt, BrokerOpt } from './contstatusreport.service';

export interface ContainerStatusFilters {
  delivery?: number;
  billto?: number;
  customer?: number;
  broker?: number;
  cmscode: string;
  movetype: string;
}
export interface ContainerStatusOptions {
  locations: (LocationOpt & { zip?: string })[];
  billtos: (BilltoOpt & { address2?: string; zip?: string; creditterms?: string; credithold?: string })[];
  customers: (CustomerOpt & { address2?: string; zip?: string; salesrep?: string; keyaccount?: string })[];
  brokers: BrokerOpt[];
  cmscodes: string[];
  movetypes: string[];
}
export type ContainerStatusRow = Record<string, string | number | boolean | null>;
export interface ContainerStatusTab {
  key: string;
  label: string;
  columns: { key: string; label: string; format: string; width: number; additional?: boolean }[];
  rows: ContainerStatusRow[];
}
export interface ContainerStatusResult {
  tabs: ContainerStatusTab[];
  criteria: string;
  filters: ContainerStatusFilters;
  total: number;
}
const base = '/reporting/container-status-report';
export const getContainerStatusOptions = async (): Promise<ContainerStatusOptions> => (await api.get(`${base}/options`)).data;
export const runContainerStatusReport = async (params: ContainerStatusFilters & { additional_fields?: string; background?: boolean }): Promise<ContainerStatusResult> =>
  (await api.get(base, { params })).data;
export const downloadContainerStatusWorkbook = (params: ContainerStatusFilters & { additional_fields?: string }): Promise<boolean> =>
  saveAs('ContainerStatus.xlsx', async () => {
    const response = await api.get<Blob>(base, { params: { ...params, format: 'xlsx' }, responseType: 'blob' });
    return response.data;
  });
